import * as a from '@mitranim/js/all.mjs'
import * as c from './conf.mjs'
import * as ut from './util-text.mjs'
import * as um from './util-misc.mjs'
import * as uc from './util-coll.mjs'
import * as uv from './util-view.mjs'
import * as uf from './util-form.mjs'
import * as uva from './util-valid.mjs'

export class FormSpeccer extends um.Ctxed {
  preinit() {}
  init() {}
  getFieldSpecs() {}
  getFormSpec() {return {fieldSpecs: this.getFieldSpecs()}}

  // Shortcut for callers who don't need the separation of various lifecycle
  // stages of the speccer.
  // TODO better name. Don't want this copy-pasted.
  async initFull(src) {
    await this.preinit(src)
    await this.init()
  }

  async initFormSpec(src) {
    await this.initFull(src)
    return this.getFormSpec()
  }

  async initForm(src) {
    await this.initFull(src)
    return this.getForm()
  }
}

export class FormSpeccerUser extends FormSpeccer {
  preinit(ent) {this.ent ??= a.optStruct(ent)}
  async init() {this.ent ??= await this.ctx.dat.user.valueTaskFresh()}

  getFieldSpecs() {
    return [
      this.getFieldSpecAvatarImageId(),
      this.getFieldSpecName(),
      this.getFieldSpecBio(),
      this.getFieldSpecBirthday(),
    ]
  }

  getFieldSpecAvatarImageId() {
    const ent = this.ent
    return {
      name: `avatarImageId`,
      type: c.UI_FIELD_TYPE_AVATAR_FILE,
      title: `Avatar`,
      value: ent?.avatarImageId,
      related: ent?.avatarImage,
      validators: [uva.validateFieldImageFileNotEmpty],
      groupTitle: `Personal Info`,
    }
  }

  getFieldSpecName() {
    const ent = this.ent
    return {
      name: `name`,
      type: c.UI_FIELD_TYPE_TEXT,
      title: `Full Name`,
      value: ent?.name,
      validators: [
        uva.validateFieldNotEmpty,
        uva.validateFieldNonEmail,
        uva.validatorFieldTextMaxLength(c.INPUT_MAX_LENGTH_NAME),
      ],
      inputProps: {
        maxLength: c.INPUT_MAX_LENGTH_NAME,
        placeholder: c.PERSON_NAME_PLACEHOLDER,
      },
      groupTitle: `Personal Info`,
    }
  }

  getFieldSpecBio() {
    const ent = this.ent
    return {
      name: `bio`,
      type: c.UI_FIELD_TYPE_TEXT_MD,
      title: `Bio`,
      value: ent?.bio,
      validators: [uva.validatorFieldTextMaxLength(c.USER_BIO_MAX_LENGTH)],
      // fieldProps: {
      //   labelSubTitle: u.maxLengthSubtitle(c.USER_BIO_MAX_LENGTH),
      // },
      inputProps: {
        placeholder: c.USER_BIO_PLACEHOLDER,
        // height: `20rem`, // WTFFFF?!
      },
      groupTitle: `About`,
    }
  }

  getFieldSpecBirthday() {
    const ent = this.ent
    return {
      name: `birthday`,
      type: c.UI_FIELD_TYPE_DATE,
      title: `Birthday`,
      value: ent?.birthday,
    }
  }
}

export class FormSpeccerPract extends FormSpeccerUser {
  async init() {
    await um.plist()
      .add(super.init())
      .add(this.initLangSels())
      .add(this.initTimezoneSels())
      .add(this.initGenderSels())
      .add(this.initCats())
  }

  async initLangSels() {
    this.langSels = await this.ctx.dat.languageSelectables.valueTask()
  }

  async initTimezoneSels() {
    this.timezoneSels = await this.ctx.dat.timezoneSelectables.valueTask()
  }

  async initGenderSels() {
    this.genderSels = await this.ctx.dat.genderSelectables.valueTask()
  }

  async initCats() {
    this.cats = await this.ctx.dat.categories.valueTask()
  }

  getFieldSpecs() {
    return [
      this.getFieldSpecAvatarImageId(),
      this.getFieldSpecName(),
      this.getFieldSpecBio(),
      this.getFieldSpecPhone(),
      this.getFieldSpecWebsite(),
      this.getFieldSpecPracticeStartAt(),
      this.getFieldSpecLanguageCodes(),
      this.getFieldSpecTimezoneName(),
      this.getFieldSpecGeoName(),
      this.getFieldSpecMainCategoryIds(),
      this.getFieldSpecConcernCategoryIds(),
      this.getFieldSpecBannerName(),
    ]
  }

  getFieldSpecAvatarImageId() {
    return {
      ...super.getFieldSpecAvatarImageId(),
      fieldProps: {
        labelWarning: a.spaced(
          `Upload a professional profile picture with your face clearly visible.`,
          `Uploading an inappropriate photo will result in termination of your account.`,
        ),
      },
    }
  }

  getFieldSpecBio() {
    const sup = super.getFieldSpecBio()
    return {
      ...sup,
      inputProps: {
        placeholder: c.PRACTITIONER_BIO_PLACEHOLDER,
      },
      validators: [uva.validateFieldNotEmpty, ...a.laxArr(sup.validators)],
    }
  }

  getFieldSpecEmail() {
    const ent = this.ent
    return {
      name: `email`,
      type: c.UI_FIELD_TYPE_EMAIL,
      title: `Email`,
      value: ent?.email,
      validators: [uva.validateFieldEmail],
      fieldProps: {widthAuto: true},
      inputProps: {
        placeholder: c.PERSON_EMAIL_PLACEHOLDER,
        disabled: true,
      },
    }
  }

  getFieldSpecPhone() {
    const ent = this.ent
    return {
      name: `phone`,
      type: c.UI_FIELD_TYPE_PHONE,
      title: `Phone`,
      value: ent?.phone,
      validators: [uva.validateFieldNotEmpty],
      inputProps: {placeholder: c.PHONE_PLACEHOLDER},
      groupTitle: `Personal Info`,
    }
  }

  getFieldSpecWebsite() {
    const ent = this.ent
    return {
      name: `website`,
      type: c.UI_FIELD_TYPE_TEXT,
      title: `Website`,
      value: ent?.website,
      validators: [uva.validateFieldNoWhitespace, uva.validateFieldOptionalUrl],
      inputProps: {placeholder: c.WEBSITE_PLACEHOLDER},
      groupTitle: `Personal Info`,
    }
  }

  getFieldSpecPracticeStartAt() {
    const ent = this.ent
    return {
      name: `practiceStartAt`,
      type: c.UI_FIELD_TYPE_DATE,
      title: `Practice Start Date`,
      value: ent?.practiceStartAt,
      groupTitle: `Personal Info`,
    }
  }

  getFieldSpecLanguageCodes() {
    const ent = this.ent
    return {
      name: `languageCodes`,
      type: c.UI_FIELD_TYPE_SELECT_LADDER,
      multiple: true,
      title: `Language`,
      value: ent?.languageCodes,
      validators: [uva.validatorFieldMultiselectBetween(1, c.MAX_LANGS)],
      inputProps: {
        placeholder: `Language`,
        selectables: this.langSels,
      },
      groupTitle: `Personal Info`,
    }
  }

  getFieldSpecTimezoneName() {
    const ent = this.ent
    return {
      name: `timezoneName`,
      type: c.UI_FIELD_TYPE_SELECT,
      multiple: false,
      title: `Timezone`,
      value: ent?.timezoneName,
      validators: [uva.validateFieldNotEmpty],
      inputProps: {selectables: this.timezoneSels, preferMarkup: true},
      groupTitle: `Personal Info`,
    }
  }

  getFieldSpecGeoName() {
    const ent = this.ent
    return {
      name: `geoName`,
      type: c.UI_FIELD_TYPE_GEO_NAME,
      title: `Geographic Location`,
      value: ent?.geoName,
      validators: [uva.validateFieldNotEmpty, uva.validateFieldCoordNotEmpty],
      coordName: `geoPoint`,
      coordValue: ent?.geoPoint,
      inputProps: {placeholder: c.LOCATION_PLACEHOLDER},
      fieldProps: {
        labelWarning: a.spaced(
          `To take full advantage of your`, c.BRAND_NAME , `membership we recommend filling this field in.`,
          `Otherwise your exposure to the potential audience and clients will be limited.`,
        ),
      },
      groupTitle: `Personal Info`,
    }
  }

  getFieldSpecGender() {
    const ent = this.ent
    return {
      name: `gender`,
      type: c.UI_FIELD_TYPE_RADIO,
      title: `Practitioner Gender`,
      value: ent?.gender,
      inputProps: {
        selectables: this.genderSels,
      },
    }
  }

  getFieldSpecSlug() {
    const ent = this.ent
    return {
      name: `slug`,
      type: c.UI_FIELD_TYPE_TEXT,
      title: a.spaced(`URL Slug on`, c.BRAND_NAME),
      validators: [uva.validateFieldNoWhitespace, uva.validateFieldNotEmpty],
      value: ent?.slug,
    }
  }

  getFieldSpecInstagramUsername() {
    const ent = this.ent
    return {
      name: `instagramUsername`,
      type: c.UI_FIELD_TYPE_TEXT,
      title: `Instagram account username`,
      validators: [uva.validateFieldNoWhitespace],
      value: ent?.instagramUsername,
    }
  }

  getFieldSpecMainCategoryIds() {
    const ent = this.ent
    return fieldSpecMainCategoryIds({
      cats: this.cats,
      title: undefined,
      max: c.MAX_PERSON_CATEGORIES,
      value: ent?.mainCategoryIds,
    })
  }

  getFieldSpecConcernCategoryIds() {
    const ent = this.ent
    return fieldSpecConcernCategoryIds({
      cats: this.cats,
      title: undefined,
      max: c.MAX_PERSON_CONCERNS,
      value: ent?.concernCategoryIds,
    })
  }

  getFieldSpecInsuranceNames() {
    const ent = this.ent
    return {
      name: `insuranceNames`,
      type: c.UI_FIELD_TYPE_INPUT_LADDER,
      multiple: true,
      value: ent?.insuranceNames,
    }
  }

  getFieldSpecCertImageIds() {
    const ent = this.ent
    return {
      name: `certImageIds`,
      type: c.UI_FIELD_TYPE_IMAGE_FILE,
      value: ent?.certImageIds,
      related: ent?.certImages,
      multiple: true,
      inputProps: {big: true},
    }
  }

  getFieldSpecBannerName() {
    const ent = this.ent
    return {
      name: `bannerName`,
      type: c.UI_FIELD_TYPE_SELECT,
      value: ent?.bannerName,
      selectables: c.LP_BANNER_SELECTABLES,
    }
  }
}

export class FormSpeccerOrg extends FormSpeccerPract {
  getFieldSpecs() {
    return [
      this.getFieldSpecCoverImageId(),
      this.getFieldSpecBio(),
      this.getFieldSpecPhone(),
      this.getFieldSpecWebsite(),
      this.getFieldSpecPracticeStartAt(),
      this.getFieldSpecLanguageCodes(),
      this.getFieldSpecTimezoneName(),
    ]
  }

  getFieldSpecName() {
    return {
      ...super.getFieldSpecName(),
      fieldProps: {label: `Organization Name`},
      inputProps: {placeholder: c.ORG_NAME_PLACEHOLDER},
    }
  }

  getFieldSpecPracticeStartAt() {
    return {
      ...super.getFieldSpecPracticeStartAt(),
      title: `Day of company incorporation`,
    }
  }

  getFieldSpecBio() {
    return {
      ...super.getFieldSpecBio(),
      inputProps: {
        placeholder: c.ORGANIZATION_BIO_PLACEHOLDER,
      },
      fieldProps: {
        labelWarning: [
          `Describe your organization for the best experience on `, c.BRAND_NAME, `. Share its story, `,
          `values and mission. Make sure to talk about your company, not your personal biography.`,
        ],
      },
      groupTitle: `About Organization`,
    }
  }

  getFieldSpecCoverImageId() {
    const ent = this.ent
    return {
      name: `coverImageId`,
      type: c.UI_FIELD_TYPE_IMAGE_FILE,
      value: ent?.coverImageId,
      related: ent?.coverImage,
      validators: [uva.validateFieldImageFileNotEmpty],
      fieldProps: {
        labelWarning: a.spaced(
          `Upload an official logo of your organization. Uploading an inappropriate image will result`,
          `in termination of your account.`,
        ),
      },
      groupTitle: `Company Logo`,
    }
  }
}

export async function fetchFormPractitioner(ctx) {
  return new uf.Form(
    await new FormSpeccerPract(ctx).initFormSpec(),
  )
}

export async function fetchFormUpgradeToPractitioner(ctx) {
  return new FormUpgradeToPractitioner(
    await new FormSpeccerPract(ctx).initFormSpec(),
  )
}

class FormUpgradeToPractitioner extends uf.Form {
  async toEntity(ctx) {
    return {...await super.toEntity(ctx), isPractitioner: true}
  }
}

export async function fetchFormUpgradeToOrganization(ctx) {
  return new FormUpgradeToOrganization(
    await new FormSpeccerOrg(ctx).initFormSpec(),
  )
}

class FormUpgradeToOrganization extends FormUpgradeToPractitioner {
  async toEntity(ctx) {
    return {...await super.toEntity(ctx), isOrganization: true}
  }
}

export async function fetchFormArticle(ctx, ent) {
  a.optStruct(ent)

  const {
    categories,
    languageSelectables,
  } = await um.pdict().funs({
    categories: () => ctx.dat.categories.valueTask(),
    languageSelectables: () => ctx.dat.languageSelectables.valueTask(),
  })

  return new uf.Form({
    fieldSpecs: [
      {
        name: `imageId`,
        type: c.UI_FIELD_TYPE_IMAGE_FILE,
        title: `Cover Image (${ut.extsToFileInputAccept(c.IMAGE_EXTS)})`,
        value: ent?.imageId,
        related: ent?.image,
        validators: [uva.validateFieldImageFileNotEmpty],
      },
      {
        name: `title`,
        type: c.UI_FIELD_TYPE_TEXT,
        value: ent?.title,
        validators: [uva.validateFieldNotEmpty],
      },
      {
        name: `content`,
        type: c.UI_FIELD_TYPE_TEXT_MD,
        value: ent?.content,
        validators: [
          uva.validateFieldNotEmpty,
          uva.validatorFieldTextMinLength(c.ARTICLE_MIN_LENGTH),
        ],
      },
      {
        name: `languageCode`,
        type: c.UI_FIELD_TYPE_SELECT,
        multiple: false,
        title: `Language`,
        value: ent?.languageCode,
        validators: [uva.validateFieldNotEmpty],
        inputProps: {
          placeholder: `Language`,
          selectables: languageSelectables,
        },
      },
      fieldSpecMainCategoryIds({
        cats: categories,
        max: c.MAX_ENTITY_CATEGORIES,
        value: ent?.mainCategoryIds,
      }),
      fieldSpecConcernCategoryIds({
        cats: categories,
        max: c.MAX_ENTITY_CONCERNS,
        value: ent?.concernCategoryIds,
        validators: undefined,
      }),
    ],
  })
}

export async function fetchFormSpecEventDateTime(ctx, ent) {
  return {
    fieldSpecs: uc.vacOf(
      {
        name: `startAt`,
        type: c.UI_FIELD_TYPE_DATETIME,
        title: `Start At`,
        validators: [uva.validateFieldNotEmpty],
        inputProps: {
          class: `form-input`,
          min: ut.formatDateIsoWithTimeTimezoneOffset(new Date()),
          autocomplete: false,
        },
        value: ent?.startAt,
      }
    )
  }
}

export function formVid(ent) {return new uf.Form(formSpecVid(ent))}

export function formSpecVid(ent) {
  return {
    entity: ent,
    fieldSpecs: [
      {
        name: `title`,
        type: c.UI_FIELD_TYPE_TEXT,
        title: `Title`,
        value: ent?.title,
        validators: [uva.validateFieldNotEmpty],
      },
      {
        name: `description`,
        type: c.UI_FIELD_TYPE_TEXT_MD,
        title: `Description`,
        value: ent?.description,
        validators: [uva.validateFieldNotEmpty],
      },
      {
        name: `imageId`,
        type: c.UI_FIELD_TYPE_IMAGE_FILE,
        value: ent?.imageId,
        related: ent?.image,
        title: `Cover Image (appears for users without access)`,
        validators: [uva.validateFieldNotEmpty],
      },
    ],
  }
}

export const fieldSpecContent = {
  name: `content`,
  type: c.UI_FIELD_TYPE_TEXTAREA,
  inputProps: {
    placeholder: c.COMMENT_PLACEHOLDER,
    class: `--std`,
    maxCharacters: c.TEXTAREA_MAX_COUNT_CHARACTERS,
  },
}

export function formSpecReview(ratingConsts) {
  return {
    fieldSpecs: [
      fieldSpecContent,
      ...a.map(ratingConsts, fieldSpecRating),
    ],
  }
}

// See rating definitions in `const.js` such as `c.RATING_EXPERTISE`.
export function fieldSpecRating({name, title, description}) {
  return {
    name,
    title,
    description,
    'data-test': `leave-review-about-service-social-skills`,
    type: c.UI_FIELD_TYPE_STAR_RATING,
    validators: [uva.validateFieldNotEmpty],
    fieldProps: uv.testProps(name && `rating-${name}`),
    inputProps: {
      starCount: c.STAR_RATING_MAX,
    },
  }
}

// TODO move to server.
// TODO dedup with `fieldSpecMainCategories` / `fieldSpecConcernCategories`.
export async function fetchCatSlugFilterSpecs(ctx) {
  const cats = await ctx.dat.categories.valueTask()

  return [
    {
      name: `mainCategorySlugs`,
      type: c.UI_FIELD_TYPE_SELECT,
      inputProps: {
        placeholder: `Category`,
        selectables: cats.onlyMain().selsBySlug(),
      },
      partitions: [c.FILTER_PARTITION_MAIN],
    },
    {
      name: `concernCategorySlugs`,
      type: c.UI_FIELD_TYPE_SELECT,
      inputProps: {
        placeholder: `Concern`,
        left: true,
        selectables: cats.onlyConcern().selsBySlug(),
      },
      partitions: [c.FILTER_PARTITION_MAIN],
    },
  ]
}

export function fieldSpecFeedOrderings(selectables) {
  return {
    name: `orderings`,
    type: c.UI_FIELD_TYPE_SELECT,
    inputProps: {
      placeholder: `Sort`,
      selectables: [c.SELECTABLE_ALL, ...selectables],
    },
    partitions: [c.FILTER_PARTITION_MAIN],
  }
}

function fieldSpecMainCategories({sels, max}) {
  return {
    type: c.UI_FIELD_TYPE_SELECT_LADDER,
    multiple: true,
    title: `Categories`,
    validators: [uva.validatorFieldMultiselectBetween(1, max)],
    inputProps: {
      placeholder: `Category`,
      selectables: sels,
      maxSelected: max,
    },
    groupTitle: `Search or choose your categories`,
  }
}

function fieldSpecConcernCategories({sels, max}) {
  return {
    type: c.UI_FIELD_TYPE_SELECT_LADDER,
    multiple: true,
    title: `Concerns`,
    validators: [uva.validatorFieldMultiselectBetween(1, max)],
    inputProps: {
      placeholder: `Concern`,
      selectables: sels,
      maxSelected: max,
    },
    groupTitle: `Search or choose your concerns`,
  }
}

export function fieldSpecMainCategoryIds({cats, max, ...rest}) {
  return {
    ...fieldSpecMainCategories({sels: cats.onlyMain().selsById(), max}),
    name: `mainCategoryIds`,
    ...rest,
  }
}

function _fieldSpecMainCategorySlugs({cats, max, ...rest}) {
  return {
    ...fieldSpecMainCategories({sels: cats.onlyMain().selsBySlug(), max}),
    name: `mainCategorySlugs`,
    ...rest,
  }
}

export function fieldSpecConcernCategoryIds({cats, max, ...rest}) {
  return {
    ...fieldSpecConcernCategories({sels: cats.onlyConcern().selsById(), max}),
    name: `concernCategoryIds`,
    ...rest,
  }
}

function _fieldSpecConcernCategorySlugs({cats, max, ...rest}) {
  return {
    ...fieldSpecConcernCategories({sels: cats.onlyConcern().selsBySlug(), max}),
    name: `concernCategorySlugs`,
    ...rest,
  }
}

export class FormPractFilters extends uf.Form {
  async toEntity(ctx) {
    const {practitionerOffers, yearsOfPracticeRange, ...rest} = await super.toEntity(ctx)

    return {
      ...rest,

      ...a.find(
        c.PRACTITIONER_OFFERS_SELECTABLES,
        val => val.value === practitionerOffers,
      )?.values,

      ...a.find(
        c.PRACTITIONER_YEARS_OF_PRACTICE_RANGE_SELECTABLES,
        val => val.value === yearsOfPracticeRange,
      )?.values,

      ...rest.geoName?.point,
      geoName: undefined,
      geoPoint: undefined,
    }
  }
}
